import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles<void, "title">()(
  (theme, _params, classes) => ({
    link: {
      color: "inherit",
      textDecoration: "none",
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(1),
      marginBottom: theme.spacing(2),
    },
    galleryImageContainer: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(1),
      "&:hover": {
        [`& .${classes.title}`]: {
          color: theme.palette.text.secondary,
        },
      },
    },
    galleryImage: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      transition: "transform 0.3s ease, filter 0.1s ease",
      borderRadius: 8,
      "&:hover": {
        filter: "brightness(90%)",
        transform: "scale(1.025)",
        zIndex: 0,
      },
    },
    title: {
      color: theme.palette.primary.main,
      fontSize: "0.8rem",
      "&:hover": {
        color: theme.palette.text.secondary,
      },
    },
    controls: {
      display: "flex",
      position: "absolute",
      top: theme.spacing(2),
      right: theme.spacing(2),
      [theme.breakpoints.down("md")]: {
        top: theme.spacing(1),
        right: theme.spacing(1),
      },
    },
  })
);
